import { createSelector } from 'reselect';

import { isMarkedToDelete } from '.';

export const getItineraryScheduleSelector = (state) => state.itineraryDetails.schedule;
export const getIsInitialized = (state) => state.itineraryDetails.initialized;
export const getItineraryScheduleTypeSelector = (state) => state.itineraryDetails.schedule.type;

const scheduleItemsSelector = (state) => state.itineraryDetails.schedule.items;
export const getScheduleItemsSelector = createSelector(scheduleItemsSelector, (items) =>
  items.filter((item) => !isMarkedToDelete(item)),
);
